import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { img } from '../../config';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      color: theme.palette.primary.main,
      textAlign: 'center',
      marginTop: 0,
    },
    '& img': {
      width: '100%',
    },
  },
  words: {
    marginTop: 20,
    textAlign: 'center',
    '& span': {
      display: 'inline-block',
      margin: '0.25em',
      padding: '0.15em 1em',
      borderRadius: '1em',
      background: theme.palette.primary.main,
      color: '#fff',
    },
  },
  sample: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
    fontFamily: theme.typography.body1.fontFamily,
  },
  correct: {
    color: theme.palette.error.main,
  },
  incorrect: {
    color: theme.palette.success.main,
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 20,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

function NewExercise(props) {
  const classes = useStyles();
  const { exercise, finishExercise, close } = props.exerciseProps;

  useEffect(() => {
    finishExercise();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={classes.wrapper}>
      <div>
        <h3>Naszkicuj wyrazy, których się chcesz nauczyć</h3>
        <img src={img('umbrella.jpg')} alt='' />
        <div className={classes.words}>
          {exercise.map(word => <span key={word}>{word}</span>)}
        </div>
        <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(NewExercise);